import * as React from "react";
const SvgFiRrSunriseAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sunrise-alt_svg__a)">
      <path
        fill="#062147"
        d="M23 24h-4.078a2 2 0 0 1-1.972-1.711 5.009 5.009 0 0 0-9.9 0 2 2 0 0 1-1.971 1.71H1a1 1 0 1 1 0-2h4.079c.077-.55.22-1.09.428-1.606l-3.525-2.044a1 1 0 1 1 1-1.731l3.529 2.046q.509-.64 1.151-1.148l-2.044-3.532a1 1 0 0 1 1.731-1l2.044 3.527A7 7 0 0 1 11 16.07V12a1 1 0 0 1 2 0v4.072c.551.08 1.09.227 1.607.437l2.044-3.528a1 1 0 0 1 1.731 1l-2.047 3.53q.642.508 1.151 1.149l3.529-2.046a1 1 0 0 1 1 1.73L18.5 20.392c.21.519.357 1.062.436 1.617L23 22a1 1 0 0 1 0 2M15.705 3.292l-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.415L11 3.414V8a1 1 0 0 0 2 0V3.414l1.3 1.293a1 1 0 0 0 1.41-1.415z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sunrise-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSunriseAlt;
